import React from 'react';
import { Modal } from 'antd';
import Button from '../button';
import CloseIcon from '../../../assets/images/icons/icons-close2.svg';
import './modal.scss';

const CustomModal = ({
  children,
  title,
  open,
  onClose,
  renderFooter = null,
  destroyOnClose = true,
  ...rest
}) => {
  if (!open) return null;

  return (
    <Modal
      footer={null}
      visible={open}
      width={1000}
      onCancel={onClose}
      destroyOnClose={destroyOnClose}
      className="custom-modal"
      {...rest}
    >
      <div className="custom-ant-modal__header">
        <span className="title">{title}</span>
        <Button className="close-icon" type="primary" size="large" onClick={onClose}>
          <img src={CloseIcon} className="icon" alt="edit icon" />
        </Button>
      </div>
      <div className="custom-ant-modal__body">{children}</div>
      {renderFooter && <div className="custom-ant-modal__footer">{renderFooter}</div>}
    </Modal>
  );
};

export default CustomModal;
